const employeeNavigation = {
  items: [
    {
      name: 'Withdrawal Operations',
      url: '/employee/withdrawals',
      icon: 'fa fa-money'
    },
    {
      name: 'Referrals',
      url: '/refer',
      icon: 'fa fa-user-plus'
    }
  ]
};

export default employeeNavigation;
